<!-- 权责详情页 -->
<template>
    <div class="v-details">
        <div class="details-header">
            <v-header :isShowSearch="isShowSearch"></v-header>
        </div>
        <div class="details-content">
            <Breadcrumb>
                <BreadcrumbItem to="/accrual">首页</BreadcrumbItem>
                <BreadcrumbItem>事项详情</BreadcrumbItem>
            </Breadcrumb>
            <div class="details-title">
                <h2>{{ DetailsData.title }}</h2>
            </div>
            <div class="details-panel">
                <div class="details-panel-item panel-item-basic">
                    <div class="details-panel-title">
                        <i class="panel-title-icon icon-basic-info"></i>
                        <h3>基本信息</h3>
                    </div>
                    <div class="details-panel-info">
                        <table class="basicinfo-table" cellspacing="0" cellpadding="0">
                            <tr class="table-border-tr">
                                <td class="table-subtitle">事项编码</td>
                                <td class="table-content">{{ DetailsData.sxbm }}</td>
                                <td class="table-subtitle">行使层级</td>
                                <td class="table-content">{{ DetailsData.xscj }}</td>
                                <td v-if="$route.query.xscj == '06'" class="table-subtitle">权责归口</td>
                                <td v-else class="table-subtitle">所属领域</td>
                                <td v-if="$route.query.xscj == '06'" class="table-content">{{ DetailsData.qzgk }}</td>
                                <td v-if="$route.query.xscj == '05'" class="table-content">{{ DetailsData.qzfw }}</td>
                                <td v-else>{{ DetailsData.zqly | renderZqly }}</td>
                            </tr>
                            <tr>
                                <td v-if="$route.query.xscj == '05'" class="table-subtitle">事项类别</td>
                                <td v-else class="table-subtitle">事项类型</td>
                                <td v-if="$route.query.xscj == '05'" class="table-content">{{ DetailsData.qzlb }}</td>
                                <td v-else class="table-content">{{ DetailsData.zqlx }}</td>
                                <td class="table-subtitle">行使主体</td>
                                <td class="table-content">{{ DetailsData.xszt | renderXszt }}</td>
                                <td class="table-subtitle">行使主体性质</td>
                                <td class="table-content">{{ DetailsData.xsztxz }}</td>
                            </tr>
                        </table>

                        <!-- <Row>
              <Col span="3">
              <ul>
                <li class="info-title">事项编码</li>
                <li class="info-title">事项类型</li>
              </ul>
              </Col>
              <Col span="5">
              <ul>
                <li class="info-content">{{ DetailsData.sxbm }}</li>
                <li class="info-content">{{ DetailsData.zqlx }}</li>
              </ul>
              </Col>
              <Col span="3">
              <ul>
                <li class="info-title">行使层级</li>
                <li class="info-title">行使主体</li>
              </ul>
              </Col>
              <Col span="5">
              <ul>
                <li class="info-content">{{ DetailsData.xscj }}</li>
                <li class="info-content">{{ DetailsData.xszt }}</li>
              </ul>
              </Col>
              <Col span="3">
              <ul>
                <li class="info-title">所属领域</li>
                <li class="info-title">行使主体性质</li>
              </ul>
              </Col>
              <Col span="5">
              <ul>
                <li class="info-content">{{ DetailsData.zqly }}</li>
                <li class="info-content">{{ DetailsData.xsztxz }}</li>
              </ul>
              </Col>
            </Row> -->
                    </div>
                </div>
                <Spin fix v-if="spin">
                    <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
                    <div>加载中...</div>
                </Spin>
                <!-- 村居级特殊数据处理 -->
                <div class="details-panel-item panel-item-place" ref="panel-item-place"
                    :class="DetailsData.countryLawList.length > 3 ? 'default-panel-max' : 'default-panel-height'"
                    v-if="DetailsData.countryLawList && DetailsData.countryLawList.length && showXJData">
                    <div class="details-panel-title">
                        <i class="panel-title-icon icon-place-info"></i>
                        <h3>设定依据</h3>
                    </div>
                    <div class="table-panel" v-for="item in DetailsData.countryLawList">
                        <table class="details-table" cellspacing="0" cellpadding="0">
                            <tr>
                                <td class="table-title" rowspan="4">设立依据</td>
                                <td class="table-subtitle">法律法规名称</td>
                                <td class="table-content">{{ item.lawTitle }}</td>
                                <td class="table-subtitle">颁布机关</td>
                                <td class="table-content">{{ item.bbjg }}</td>
                            </tr>
                            <tr class="table-border-tr">
                                <td class="table-subtitle">依据文号</td>
                                <td class="table-content">{{ item.yjwh }}</td>
                                <td class="table-subtitle">实施日期</td>
                                <td class="table-content">{{ item.ssTime }}</td>
                            </tr>
                            <tr class="table-full">
                                <td class="table-subtitle">条款号</td>
                                <td class="table-content" colspan="3" v-html="renderContent(item.tkNum)"></td>
                            </tr>
                            <tr class="table-full" colspan="3">
                              <td class="table-subtitle">条款内容</td>
                              <td class="table-content" colspan="3" v-html="renderContent(item.content)"></td>
                          </tr>
                        </table>
                    </div>
                </div>
                <div class="details-panel-item panel-item-country" ref="panel-item-country"
                    v-if="DetailsData.countryLawList && DetailsData.countryLawList.length && !showXJData">
                    <!-- <div class="spin-content">
            <Spin fix v-if="spinCountry">
              <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
              <div>加载中...</div>
            </Spin>
          </div> -->
                    <div class="details-panel-title">
                        <i class="panel-title-icon icon-country-info"></i>
                        <h3>国家级设定依据</h3>
                    </div>
                    <div class="table-panel" v-for="item in DetailsData.countryLawList">
                        <table class="details-table" cellspacing="0" cellpadding="0">
                            <tr>
                                <td class="table-title" rowspan="4">设立依据</td>
                                <td class="table-subtitle">法律法规名称</td>
                                <td class="table-content">{{ item.lawTitle }}</td>
                                <td class="table-subtitle">颁布机关</td>
                                <td class="table-content">{{ item.bbjg }}</td>
                            </tr>
                            <tr class="table-border-tr">
                                <td class="table-subtitle">依据文号</td>
                                <td class="table-content">{{ item.yjwh }}</td>
                                <td class="table-subtitle">实施日期</td>
                                <td class="table-content">{{ item.ssTime }}</td>
                            </tr>
                            <tr class="table-full">
                                <td class="table-subtitle">条款号</td>
                                <td class="table-content" colspan="3" v-html="renderContent(item.tkNum)"></td>
                            </tr>
                            <tr class="table-full">
                              <td class="table-subtitle">条款内容</td>
                              <td class="table-content" colspan="3" v-html="renderContent(item.content)"></td>
                          </tr>
                        </table>
                    </div>
                    <!-- <div class="details-panel-info" v-for="item in DetailsData.countryLawList">
            <Row>
              <Col span="2">
              <ul>
                <li class="info-main-title">设立依据</li>
              </ul>
              </Col>
              <Col span="3">
              <ul>
                <li class="info-title">法律法规名称</li>
                <li class="info-title">依据文号</li>
                <li class="info-title">条款号</li>
              </ul>
              </Col>
              <Col span="8">
              <ul>
                <li class="info-content">{{ item.lawTitle }}</li>
                <li class="info-content">{{ item.yjwh }}</li>
                <li class="info-content">
                  {{ item.tkNum }}
                </li>
              </ul>
              </Col>
              <Col span="3">
              <ul>
                <li class="info-title">颁布机关</li>
                <li class="info-title">实施日期</li>
                <li class="info-title">条款内容</li>
              </ul>
              </Col>
              <Col span="8">
              <ul>
                <li class="info-content">
                  {{ item.bbjg }}
                </li>
                <li class="info-content">{{ item.ssTime }}</li>
                <li class="info-content">
                  {{ item.content }}
                </li>
              </ul>
              </Col>
            </Row>
          </div> -->
                </div>
                <div class="details-panel-item panel-item-place" ref="panel-item-place"
                    :class="DetailsData.localLawList.length > 3 ? 'default-panel-max' : 'default-panel-height'"
                    v-if="DetailsData.localLawList && DetailsData.localLawList.length && !showXJData">
                    <!-- <div class="spin-content">
            <Spin fix v-if="spinPlace">
              <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
              <div>加载中...</div>
            </Spin>
          </div> -->
                    <!-- <Spin size="large" fix v-if="spinPlace"></Spin> -->
                    <div class="details-panel-title">
                        <i class="panel-title-icon icon-place-info"></i>
                        <h3>省级设定依据</h3>
                    </div>
                    <div class="table-panel" v-for="item in DetailsData.localLawList">
                        <table class="details-table" cellspacing="0" cellpadding="0">
                            <tr>
                                <td class="table-title" rowspan="4">设立依据</td>
                                <td class="table-subtitle">法律法规名称</td>
                                <td class="table-content">{{ item.lawTitle }}</td>
                                <td class="table-subtitle">颁布机关</td>
                                <td class="table-content">{{ item.bbjg }}</td>
                            </tr>
                            <tr class="table-border-tr">
                                <td class="table-subtitle">依据文号</td>
                                <td class="table-content">{{ item.yjwh }}</td>
                                <td class="table-subtitle">实施日期</td>
                                <td class="table-content">{{ item.ssTime }}</td>
                            </tr>
                            <tr class="table-full">
                                <td class="table-subtitle">条款号</td>
                                <td class="table-content" colspan="3" v-html="renderContent(item.tkNum)"></td>
                            </tr>
                            <tr class="table-full" colspan="3">
                              <td class="table-subtitle">条款内容</td>
                              <td class="table-content" colspan="3" v-html="renderContent(item.content)"></td>
                          </tr>
                        </table>
                    </div>

                    <!-- <div class="details-panel-info" v-for="item in DetailsData.localLawList">
            <Row>
              <Col span="2">
              <ul>
                <li class="info-main-title">设立依据</li>
              </ul>
              </Col>
              <Col span="3">
              <ul>
                <li class="info-title">法律法规名称</li>
                <li class="info-title">依据文号</li>
                <li class="info-title">条款号</li>
              </ul>
              </Col>
              <Col span="8">
              <ul>
                <li class="info-content">{{ item.lawTitle }}</li>
                <li class="info-content">{{ item.yjwh }}</li>
                <li class="info-content">
                  <Poptip word-wrap width="200" :content="item.tkNum" trigger="hover" :width="popWidth"
                    placement="bottom-start">
                    {{ renderContent(item.tkNum) }}
                  </Poptip>
                </li>
              </ul>
              </Col>
              <Col span="3">
              <ul>
                <li class="info-title">颁布机关</li>
                <li class="info-title">实施日期</li>
                <li class="info-title">条款内容</li>
              </ul>
              </Col>
              <Col span="8">
              <ul>
                <li class="info-content">
                  {{ item.bbjg }}
                </li>
                <li class="info-content">{{ item.ssTime }}</li>
                <li class="info-content">
                  {{ item.content }}
                </li>
              </ul>
              </Col>
            </Row>
          </div> -->
                </div>
                <div v-if="DetailsData.localLawList && DetailsData.localLawList.length > 3">
                    <div class="btn-open" v-if="!IsOpen" @click="toggleNavPanel()">查看更多部门分类</div>
                </div>
            </div>
        </div>
        <BackTop :height="backTopHei" :duration="backTopDur" class="btn-backtop">
            <div class="btn-backtop-icon"></div>
        </BackTop>
        <div class="accrual-footer">
            <div class="accraul-introduce">
                <a href="javascript:void(0);">北大法宝权责清单智能管理系统简介</a>
            </div>
            <div class="accrual-copyright">
                <div class="copyright-item">
                    <a href="https://pkulaw.com/helps/58.html" target="_blank">英华介绍</a>
                    <span>::</span>
                    <a href="http://www.pkulaw.cn/help/index.html?item=FBKH" target="_blank">经典客户</a>

                    <span>::</span>
                    <a href="https://pkulaw.com/help/more-service-law-notice.html" target="_blank">法律声明</a>
                    <span>::</span>
                    <a href="http://www.pkulaw.cn/css/websit_map.htm" target="_blank">网站地图</a>
                    <span>::</span>

                    <a href="mailto:info@chinalawinfo.com">企业邮箱</a>
                </div>
                <p>版权所有 ：北京北大英华科技有限公司 北京大学法制信息中心 <a href="http://www.beian.miit.gov.cn/"
                        target="_blank">京ICP证010230-17号</a></p>
                <div class="copyright-logo">
                    <a href="http://www.pkulaw.cn/help/ad/20140818/index.html" rel="nofollow" target="_blank">
                        <img src="https://pkulaw.com/content/images/bdfb.jpg" alt="">
                    </a>
                    <a href="https://ss.knet.cn/verifyseal.dll?sn=e13042211010040250ewgy000000&amp;ct=df&amp;a=1&amp;pa=0.3386153630929789"
                        rel="nofollow" target="_blank"></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { reqDetailsData, reqDetailsDataByCont } from "@/api/index";
    import VHeader from '@/views/header/VHeader.vue'
    export default {
        name: 'VDetails',
        components: {
            VHeader
        },
        data() {
            return {
                spin: true,
                spinCountry: true,
                spinPlace: true,
                isShowSearch: '3',
                popWidth: 500,
                DetailsData: [],
                storageData: [],
                // 是否展开全部部门
                IsOpen: false,
                // 返回顶部临界值
                backTopHei: 10,
                // 返回顶部动画时长
                backTopDur: 600,
                showXJData: false
            }
        },
        computed: {
            cPanelHeight: function () {
                // 标题96 + 底边margin50 + 256*条数
                return this.DetailsData.localLawList.length * 196 + 96 + 50;
            }
        },
        watch: {

        },
        created() {

        },
        mounted() {
            this.DetailsData = this.$route.params;
            this.getDetailsData();
        },
        destoryed() {

        },
        methods: {
            renderZqly(data) {
                if (data) {
                    console.log(this.DetailsData)
                    let reg = /^[省][市][区]$/g;
                    console.log(data)
                    console.log(data.match(reg))
                    console.log(data.search(reg))
                }
            },
            renderXszt(data) {

            },
            // 获取详情页数据
            getDetailsData() {
                reqDetailsData(this.$route.query.id, {}).then(res => {
                    if (res.code === 0) {
                        this.spin = false;
                        this.spinCountry = false;
                        this.spinPlace = false;
                        this.storageData = res.data;
                        this.DetailsData = res.data;

                        if (this.DetailsData.localLawList.length > 3) {
                            this.DetailsData.localLawList.length = 3;
                        }
                    }
                    if (res.code === -2) {
                      this.getDetailsDataByCont();
                    }
                });
            },
            getDetailsDataByCont() {
              reqDetailsDataByCont(this.$route.query.id, {}).then(res => {
                this.spin = false;
                this.storageData = res.data;
                this.DetailsData = res.data;
                if (!res.data.totalnewlawid) {
                  this.showXJData = true;
                }
                // if (this.DetailsData.localLawList.length > 3) {
                //     this.DetailsData.localLawList.length = 3;
                // }
              });
            },
            // 渲染文本
            // renderContent(val) {
            // let res = '';
            // if (val.length > 20) {
            //   res = val.substring(0, 20) + '...';
            // }
            // return val;
            // },
            // 展开面板，查看全部职权部门
            toggleNavPanel() {
                this.IsOpen = !this.IsOpen;
                this.DetailsData = this.storageData;
                // let tempStyle = this.IsOpen ? 'height: ' + this.cPanelHeight + 'px' : 'height 96px';
                // this.$refs['panel-item-place'].style = tempStyle;
            },
            renderContent(str) {
                let result = '';
                if (str) {
                  result = str.replace(/\n/g, "<br>");
                }
                return result;
            }
        },
        filters: {
            renderZqly: function (data) {
                if (data) {
                    let reg = /部|厅|局|委员会|办公室|委/g;
                    console.log(data.search(reg))
                    let xx = data.substr(0, data.search(reg));
                    return xx
                }
            },
            renderXszt: function (data) {
                if (data) {
                    let reg = /省|市/g;
                    // let reg = /省|市|区/g;
                    return data.substr(data.search(reg) + 1, data.length)
                }
            }
        }
    }
</script>

<style scoped>
    .v-details {
        min-height: 100%;
        background-color: #f7f8f8;
    }

    .details-header {
        background-color: #fff;
    }

    .details-content {
        overflow: hidden;
        margin: 0 auto 30px;
        padding: 0 20px;
        width: 1200px;
        min-height: 700px;
    }

    .details-title h2 {
        font-size: 18px;
        font-weight: bolder;
        color: #2d4060;
    }

    .details-panel {
        position: relative;
        overflow: hidden;
        margin: 12px 0 0;
        /* margin-bottom: 30px; */
        padding: 0 16px;
        /* border-radius: 3px; */
        background-color: #fff;
    }

    .details-panel-item {
        overflow: hidden;
        position: relative;
        transition: height 0.6s ease;
    }

    .panel-item-place {
        /* height: 894px; */
        margin-bottom: 30px;
    }

    .default-panel-height {
        height: auto;
    }

    .default-panel-max {
        /* height: 714px; */
    }

    .panel-item-country {
        margin-bottom: 30px;
    }

    .details-panel-title {
        display: flex;
        align-items: center;
        padding: 16px 0;
    }

    .details-panel-title h3 {
        font-size: 14px;
        font-weight: bolder;
        color: #333;
    }

    .panel-title-icon {
        margin-top: -2px;
        margin-right: 4px;
        width: 14px;
        height: 14px;
    }

    .details-panel-info {
        margin-bottom: 10px;
        /* border-left: 1px solid #c7dbe5; */
        /* border-top: 1px solid #c7dbe5; */
        /* border-radius: 3px; */
    }

    .info-title,
    .info-content {
        /* border-right: 1px solid #c7dbe5; */
        /* border-bottom: 1px solid #c7dbe5; */
    }

    .icon-basic-info {
        background: url(../../assets/icon-basic-info.png) no-repeat 0 0;
        background-size: 100% 100%;
    }

    .icon-country-info {
        background: url(../../assets/icon-country-info.png) no-repeat 0 0;
        background-size: 100% 100%;
    }

    .icon-place-info {
        background: url(../../assets/icon-place-info.png) no-repeat 0 0;
        background-size: 100% 100%;
    }

    ul {
        list-style: none;
    }

    li {
        font-size: 14px;
        color: #585f62;
    }

    .info-main-title {
        padding: 85px 0;
        border-bottom: 1px solid #65a5c4;
        text-align: center;
        background-color: #e0e8f7;
    }

    .info-title {
        padding: 18px;
        text-align: center;
        background-color: #f7f8fc;
    }

    .info-content {
        /* overflow: hidden; */
        /* text-overflow: ellipsis; */
        /* white-space: nowrap; */
        padding: 18px;
        background-color: #fff;
    }

    .btn-open {
        margin: 50px 0;
        text-align: center;
        color: #1867dd;
        cursor: pointer;
    }

    .spin-icon-load {
        animation: ani-spin 1s linear infinite;
    }

    @keyframes ani-spin {
        from {
            transform: rotate(0deg);
        }

        50% {
            transform: rotate(180deg);
        }

        to {
            transform: rotate(360deg);
        }
    }

    .table-panel {
        overflow: hidden;
        margin-bottom: 15px;
        /* border: 1px solid #e0e8f7; */
        /* border-radius: 3px; */
    }

    .details-panel-info {
        overflow: hidden;
        margin-bottom: 10px;
        /* border: 1px solid #e0e8f7; */
        border-left: none;
        /* border-radius: 3px; */
    }

    .details-table {
        width: 100%;
        border-top: 1px solid #e0e8f7;
        /* border-left: 1px solid #65a5c4; */
        /* border-top: 1px solid #e0e8f7; */
        /* border-radius: 3px; */
    }

    .details-table .table-border-tr td {
        /* border-top: 1px solid #e0e8f7; */
        /* border-bottom: 1px solid #e0e8f7; */
    }

    .details-table td {
        padding: 16px 6px;
        border-bottom: 1px solid #e0e8f7;
        border-right: 1px solid #e0e8f7;
        font-size: 14px;
        color: #585f62;
        background-color: #fff;
    }

    .details-table .table-title {
        width: 11%;
        /* border: 1px solid #65a5c4; */
        font-size: 14px;
        font-weight: bolder;
        text-align: center;
        color: #2d4060;
        background-color: #e0e8f7;
    }

    .details-table .table-subtitle {
        width: 13%;
        /* border-left: 4px solid #fff; */
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        background-color: #f7f8fc;
    }

    .details-table .table-content {
        width: 31%;
    }

    .table-full td {
      /* border: 1px solid #e0e8f7; */
      /* border-bottom: 1px solid #fff; */
    }

    .basicinfo-table {
        width: 100%;
        border-top: 1px solid #e0e8f7;
        border-bottom: 1px solid #e0e8f7;
        border-left: 1px solid #e0e8f7;
    }

    .basicinfo-table .table-border-tr td {
        /* border-top: 1px solid #e0e8f7; */
        border-bottom: 1px solid #e0e8f7;
        /* border-top: 1px solid #e0e8f7; */
        /* border-bottom: 4px solid #fff; */
    }

    .basicinfo-table td {
        padding: 16px;
        color: #585f62;
        background-color: #fff;
        border-right: 1px solid #e0e8f7;
    }

    .basicinfo-table .table-title {
        width: 11%;
        /* border: 1px solid #65a5c4; */
        font-size: 18px;
        text-align: center;
        color: #fff;
        background-color: #e0e8f7;
    }

    .basicinfo-table .table-subtitle {
        width: 13%;
        /* border-left: 1px solid #e0e8f7; */
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        background-color: #f7f8fc;
    }

    .basicinfo-table .table-content {
        width: 20%;
    }



    .accrual-footer {
        padding: 0 20px;
        color: #fff;
        background-color: #17181e;
    }

    .accraul-introduce {
        padding: 20px;
        text-align: center;
        border-bottom: 1px solid #394c5e;
        /* background-color: #17181e; */
    }

    .accraul-introduce a {
        font-size: 18px;
        color: #fff;
    }

    .accrual-copyright {
        position: relative;
        padding: 20px;
        text-align: center;
        /* background-color: #17181e; */
    }

    .accrual-copyright a {
        color: #fff;
    }

    .copyright-item {
        margin-bottom: 10px;
    }

    .copyright-logo {
        position: absolute;
        top: 24px;
        right: 60px;
    }

    .btn-backtop-icon {
        width: 44px;
        height: 48px;
        background: url(../../assets/backtop.png) 0 0 no-repeat;
    }
</style>